<template>
  <VueSidePanel
    v-model="isSidePanelOpen"
    transition-name="slide-left"
    width="42%"
    side="left"
    body-class="bbSidePanelBody bbSidePanelBody-Item"
    panel-color="transparent"
    :z-index="5000"
  >
    <template #default>
      <div class="mt-2 px-4">
        <SpellStaticCard
          :spell="spell"
          :spells="spells"
          :runes="runes"
          @add-static-spell="$emit('add-static-spell', $event)"
          @update-static-spell="$emit('update-static-spell', $event)"
          @delete-static-spell="$emit('delete-static-spell', $event)"
          @close-static-spell-panel="$emit('close-static-spell-panel', $event)"
        />
      </div>
    </template>
  </VueSidePanel>
</template>

<script>
import SpellStaticCard from './SpellStaticCard.vue'
import { VueSidePanel } from 'vue3-side-panel'
//---------
// scripts
//---------
export default {
  name: 'SpellStaticSidePanel',
  emits: [
    'add-static-spell',
    'update-static-spell',
    'delete-static-spell',
    'close-static-spell-panel',
  ],
  //------------
  // components
  //------------
  components: {
    VueSidePanel,
    SpellStaticCard,
  },
  //-------
  // props
  //-------
  props: {
    spell: {
      type: Object,
      required: false,
      default: null,
    },
    spells: {
      type: Array,
      required: false,
      default: () => [],
    },
    runes: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  //------
  // data
  //------
  data() {
    return {
      isSidePanelOpen: true, // mandatory for VueSidePanel
    }
  },
}
</script>

<style scoped>
.vsp-overlay {
  background: #1e1e1e !important;
  opacity: 0.2 !important;
}
</style>
